var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96 4.44667C11.9796 4.50509 11.9931 4.56542 12 4.62667V4.66667V8.66667C12 9.77124 11.1046 10.6667 10 10.6667H9.33333V11.3333C9.33333 12.4379 8.4379 13.3333 7.33333 13.3333H2C0.89543 13.3333 0 12.4379 0 11.3333V4.66667C0 3.5621 0.89543 2.66667 2 2.66667H2.66667V2C2.66667 0.89543 3.5621 0 4.66667 0H7.36667C7.44415 0.0095628 7.51894 0.0344942 7.58667 0.0733333C7.60657 0.0705068 7.62677 0.0705068 7.64667 0.0733333C7.71521 0.105387 7.77822 0.148144 7.83333 0.2L11.8333 4.2C11.8852 4.25511 11.9279 4.31812 11.96 4.38667V4.44667ZM9.72667 4L8 2.27333V3.33333C8 3.70152 8.29848 4 8.66667 4H9.72667ZM8 11.3333C8 11.7015 7.70152 12 7.33333 12H2C1.63181 12 1.33333 11.7015 1.33333 11.3333V4.66667C1.33333 4.29848 1.63181 4 2 4H2.66667V8.66667C2.66667 9.77124 3.5621 10.6667 4.66667 10.6667H8V11.3333ZM10 9.33333C10.3682 9.33333 10.6667 9.03486 10.6667 8.66667V5.33333H8.66667C7.5621 5.33333 6.66667 4.4379 6.66667 3.33333V1.33333H4.66667C4.29848 1.33333 4 1.63181 4 2V8.66667C4 9.03486 4.29848 9.33333 4.66667 9.33333H10Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.f63f1c2e8eb5a7e798de44b21a18905e.svg";
export { ForwardRef as ReactComponent };